import React, { useCallback, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
  AppModal,
  AppRemixIcon,
} from '@/layout/AppComponents';
import { ProgressBar } from 'react-bootstrap';
import * as currentPageAction from '../../../../../store/actions/currentPageAction';
import AuxSidebar from '../../../../Sidebar/AuxSidebar';
import { axiosPath, path } from '../../../../../routing/helpers/router';
import colors from '../../../../../constants/colors';
import Translator from '../../../../components/helpers/Translator';
import useIsMounted from '../../../../components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';

export default function ReportSidebarBlock() {
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { moduleBridgeHex, plantHex, filtersHex } = useParams();
  const auxSidebar = useSelector(
    (state) => state.currentPage?.auxSidebar?.opened
  );
  const [openOnce, setOpenOnce] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [reportUrl, setReportUrl] = useState(null);
  const [isError, setIsError] = useState(false);

  const handleAuxSidebar = () => {
    if (!openOnce) {
      setOpenOnce(true);
    }
    if (auxSidebar !== 'reports') {
      dispatch(currentPageAction.change('auxSidebar', { opened: 'reports' }));
    } else {
      dispatch(currentPageAction.change('auxSidebar', { opened: null }));
    }
  };

  // > LOAD REPORT
  const exportXls = () => axios
    .post(
        axiosPath('api_r_user_module_inecoRiskManager_risk_xls_export'),
        {
            moduleBridgeHex,
            filters: 0,
            milestone: 0,
        }
    )
    .then(({ data }) => (window.location = data))
    .catch((e) => dispatch(errorHandler(e)))
  // < LOAD REPORT

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
    setReportUrl(null);
    setIsError(false);
  }, []);

  const removeFilters = useCallback(
    () =>
      navigate(
          path({
            name: 'user_module_inecoRiskManager_risk_list',
            params: {
              moduleBridgeHex,
              page: 1,
              filtersHex: 0,
            },
          })
      ),
    [moduleBridgeHex, plantHex]
  );

  return (
    <>
      <li
        className={auxSidebar && auxSidebar === 'reports' ? 'active' : ''}
        onClick={handleAuxSidebar}
      >
        <span className="sidebar-element">
          <AppRemixIcon icon="file-chart" className="sidebar-icon" />{' '}
          <span className="sb-title">
            <Translator file="user" name="user.export.gcl" />
          </span>
        </span>
      </li>
      <AuxSidebar
        title={<Translator file="user" name="user.export.gcl" />}
        isOpen={auxSidebar && auxSidebar === 'reports'}
        width="350px"
        position="left"
        onClose={handleAuxSidebar}
      >
        <div className="p-2">
          {openOnce && (
            <>
              {filtersHex != 0 && (
                <div
                  className="alert alert-danger alert-dismissible fade show"
                  role="alert"
                >
                  <Translator
                    file="module-legalCompliance"
                    name="module.lc.export-filtered.selected-filters"
                  />
                  <button type="button" className="close" onClick={removeFilters}>
                    <AppRemixIcon icon="delete-bin-6" size={16} />
                  </button>
                </div>
              )}
              <div
                className="pointer mb-2"
                title="Excel"
                onClick={exportXls}
              >
                <AppRemixIcon
                  icon="file-excel"
                  className="sidebar-icon mr-2"
                />
                Excel
              </div>
            </>
          )}
        </div>
      </AuxSidebar>
      <AppModal
        show={showModal}
        title={
          <Translator file="module-legalCompliance" name="export.report" />
        }
        onClose={handleCloseModal}
        isCloseButton={reportUrl || isError}
      >
        {reportUrl ? (
          <div className="text-center">
            <a className="btn btn-sm btn-primary" href={reportUrl}>
              <Translator
                file="module-legalCompliance"
                name="download.report"
              />
            </a>
          </div>
        ) : isError ? (
          <div className="text-danger">
            <Translator
              file="module-legalCompliance"
              name="error.contact.admin"
            />
          </div>
        ) : (
          showModal && (
            <>
              <div>
                <Translator file="module-legalCompliance" name="downloading" />
                ...
              </div>
              <ProgressBar animated now={100} />
            </>
          )
        )}
      </AppModal>
    </>
  );
}
